import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import type * as L from 'leaflet';
import CurrentLocationMarker from '../../../Shared/Map/markers/current-location.marker';
import Colors from '../../../../helpers/colors.helper';

interface IUserLocationMarkerProps {
  position: [number, number];
}

export default function UserLocationMarker({ position }: IUserLocationMarkerProps) {
  const map = useMap();

  useEffect(() => {
    const options: L.MarkerOptions & { radius: number; weight: number; color: string; fillColor: string; fillOpacity: number } = {
      color: Colors.vtdBlue600,
      fillColor: Colors.vtdBlue1000,
      radius: 8,
      weight: 2,
      fillOpacity: 1,
    };

    const marker = new CurrentLocationMarker(position, options);
    marker.addTo(map);

    return () => {
      marker.remove();
    };
  }, [map, position]);

  return null;
}
